module.exports = __webpack_public_path__ + "img/promt.503607fa.svg";